import { Link } from 'react-router-dom'
import { HomeSvg } from '../../svg/Index'

const Breadcrumb = ({ items = [] }) => {
  
  const breadcrumbItems = [
    { label: 'Home', path: '/', icon: <HomeSvg /> },
    ...items
  ];
  
  return (
    <section className='breadcrumb-section py-3'>
      <div className='container'>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            {breadcrumbItems.map((item, index) => {
              const isLast = index == breadcrumbItems.length - 1;

              return (
                <li
                  key={index}
                  className={`breadcrumb-item ${isLast ? 'active' : ''}`}
                  aria-current={isLast ? 'page' : undefined}
                >
                  {isLast ? (
                    <span className='font--15'>
                      {item.icon && <span className='me-1'>{item.icon}</span>}
                      {item.label}
                    </span>
                  ) : (
                    <Link to={item.path || '#'} className='font--15'>
                      {item.icon && <span className='me-1'>{item.icon}</span>}
                      {item.label}
                    </Link>
                  )}
                </li>
              );
            })}
          </ol>
        </nav>
      </div>
    </section>
  );
};

export default Breadcrumb;